import { Component, Inject, OnInit, EventEmitter, Input } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { BeneficiosTributariosDeduccionesEspecialesModalComponent } from '../../beneficios-tributarios/beneficios-tributarios-deducciones-especiales/beneficios-tributarios-deducciones-especiales-modal.component';
import { BeneficiosRentasExentasDeImpuestoModalComponent } from '../../beneficios-tributarios/beneficios-rentas-exentas-de-impuesto/beneficios-rentas-exentas-de-impuesto-modal.component';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

declare var require: (filename: string) => any;
var BigNumber2100 = require('bignumber.js');

BigNumber2100.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const stepsList = [
  /*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Ingresos Trabajador Independiente', listHelp: ['301'] }
];

const tableStructure = [
  { id: 'pagador', title: 'Nombre Pagador' },
  { id: 'origen', title: 'Origen información' },
  { id: 'descTipoRenta', title: 'Tipo de Renta' },
  { id: 'valor', title: 'Valor' }
];


class Form1 {
  id: number;
  idSugerida: number;
  origen: string;
  tipoRenta: string;
  descTipoRenta: string;
  valor: string;
  pagador: string;
  cesantias: string;
  retencion: string;
  aportesalud: string;
  aporteoblipension: string;
  aportevolpension: string;
  aportesAFCoAVC: string;
  cotizavolRAIS: string;
  limitanteAFC: string;
  limitanteRAIS: string;
  limitanteaportevolpension: string;
  veinticincoexento: string;
  arl: string;
  limitanteaportevolCesantias: string;
  costosGastos: string;
  perdidas: string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-ingresos-trabajador-independiente-modal',
  templateUrl: './ingresos-trabajador-independiente-modal.component.html',
  styleUrls: ['./ingresos-trabajador-independiente-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresostrabajadorindependienteModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody:Form1[] = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  //private UVT =  "42412"; //año 2023 unidad de valor tributario definida para el año para el cual se declara renta
 public UVT: string;


  rangos = [
    { desde: 0, hasta: 350, tarifa: '100' },
    { desde: 351, hasta: 410, tarifa: '0.90' },
    { desde: 411, hasta: 470, tarifa: '0.80' },
    { desde: 471, hasta: 530, tarifa: '0.60' },
    { desde: 531, hasta: 590, tarifa: '0.90' }

  ];


  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  listaTipoRenta: any;
  tablaArt73: any;
  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<IngresostrabajadorindependienteModalComponent>,
    private _componentFactory: ComponentFactoryService,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;    
  }

  ngOnInit() {
    const isArray = Array.isArray(this.model.doc.cuerpo.cs_id_648);
    if (isArray) {
      this.model.doc.cuerpo.cs_id_648 = "0";
    }

    const isArray1 = Array.isArray(this.model.doc.cuerpo.cs_id_303);
    if (isArray1) {
      this.model.doc.cuerpo.cs_id_303 = "0";
    }

    const isArray2 = Array.isArray(this.model.doc.cuerpo.cs_id_538);
    if (isArray1) {
      this.model.doc.cuerpo.cs_id_538 = "0";
    }
    
if (this.listaTipoRenta && this.listaTipoRenta.length>0) {
  this.listaTipoRenta = this.listaTipoRenta.filter(item => Number(item.valor) < 3);
  }

    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
  }

  protected controlStep(direction: DirectionType): void {

  }




  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;
    this.modelForm.origen = "";
    this.modelForm.tipoRenta = "0";
    this.modelForm.descTipoRenta = '';
    this.modelForm.descTipoRenta = '';
    this.modelForm.valor = "0";
    this.modelForm.pagador = "";
    this.modelForm.cesantias = "0";
    this.modelForm.retencion = "0";
    this.modelForm.aportesalud = "0";
    this.modelForm.aporteoblipension = "0";
    this.modelForm.aportevolpension = "0";
    this.modelForm.aportesAFCoAVC = "0";
    this.modelForm.cotizavolRAIS = "0";
    this.modelForm.limitanteAFC = "0";
    this.modelForm.limitanteRAIS = "0";
    this.modelForm.limitanteaportevolpension = "0";
    this.modelForm.veinticincoexento = "0";
    this.modelForm.arl = "0";
    this.modelForm.limitanteaportevolCesantias = "0";
    this.modelForm.costosGastos = "0";
    this.modelForm.perdidas = "0";

  }

  protected inicializeModelo() {

    if (this.model.doc.cuerpo.cc_id_309 == undefined) {

      //Casillas compuestas
      this.model.doc.cuerpo.cc_id_309 = [];  //Casilla 309	Nombre pagador 
      this.model.doc.cuerpo.cc_id_302 = [];  //Casilla 302	Origen de la Información
      this.model.doc.cuerpo.cc_id_303 = [];  //Casilla 303	Tipo de renta 
      this.model.doc.cuerpo.cc_id_304 = [];  //Casilla 304	Valor
      this.model.doc.cuerpo.cc_id_310 = [];  //Casilla 310	Retención
      this.model.doc.cuerpo.cc_id_312 = [];  //Casilla 312	Aporte a salud
      this.model.doc.cuerpo.cc_id_313 = [];  //Casilla 313	Aporte obligatorio pensión
      this.model.doc.cuerpo.cc_id_316 = [];  //Casilla 316	Aporte ARL
      this.model.doc.cuerpo.cc_id_314 = [];  //Casilla 314	Aporte voluntario a pensión
      this.model.doc.cuerpo.cc_id_315 = [];  //Casilla 315	Aporte cuenta AFC o AVC
      this.model.doc.cuerpo.cc_id_311 = [];  //Casilla 311	Aporte a cesantía 
      this.model.doc.cuerpo.cc_id_319 = [];  //Casilla 319	Limitante AFC
      this.model.doc.cuerpo.cc_id_320 = [];  //Casilla 320	Limitante aportes voluntarios pensión
      this.model.doc.cuerpo.cc_id_321 = [];  //Casilla 321	Limitante cotización RAIS
      this.model.doc.cuerpo.cc_id_322 = [];  //Casilla 322	25% Exento
      this.model.doc.cuerpo.cc_id_307 = [];  //Casilla 307	Limitantes aporte voluntario a Cesantias 
      this.model.doc.cuerpo.cc_id_308 = [];  //Casilla 308	Perdidas
      this.model.doc.cuerpo.cc_id_317 = [];  //Casilla 317 Cotización voluntaria RAIS
      this.model.doc.cuerpo.cc_id_318 = [];  //Casilla 318 Costos y gastos


      //Casillas simples
      this.model.doc.cuerpo.cs_id_305 =this.model.doc.cuerpo.cs_id_305?this.model.doc.cuerpo.cs_id_305: "0"; //Total 
      // this.model.doc.cuerpo.cs_id_301 = "0";

    }
  }


  public operacionCs305() {

    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      if(this.dataSourceBody[i].tipoRenta==='2')
          suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma);
    }
    let cas371T = '0';
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_370.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_370[con].v) == 2) {
          cas371T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_371[con].v, cas371T);
        }
      }
  
    const suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas371T, suma);
    this.model.doc.cuerpo.cs_id_305 = this.dutilidades.redondearValorMoneda(suma1, true);
    
  }


  // //========= Validaciones Casillas Ocultas=============//

  public operacionTotalizarCasillasOcultas(){
    if (this.model.doc.cuerpo.cc_id_309 == undefined) {
      for(let i=0; i<this.model.doc.cuerpo.cc_id_309.length; i++){
        this.operacionCs319(i);
        this.operacionCs320(i);
        this.operacionCs321(i);
        this.operacionCs322(i);
        this.operacionCs307(i);
        this.operacionCs308(i);
      }
    }
  }

  public operacionCs308(i: number) {

    let cas370bool = false;
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_370.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_370[con].v) == 2) {
          cas370bool = true;
          break;
        }
      }
    if (this.model.doc.cuerpo.cc_id_303[i] != undefined && this.model.doc.cuerpo.cc_id_303[i].v === '2' && cas370bool) {

      if (this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MAYOR_QUE,
        this.model.doc.cuerpo.cc_id_318[i].v, this.model.doc.cuerpo.cc_id_315[i].v, true)) {
        this.model.doc.cuerpo.cc_id_308[i].v = this.model.doc.cuerpo.cc_id_315[i].v;
      }
      else {
        this.model.doc.cuerpo.cc_id_308[i].v = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,
          this.model.doc.cuerpo.cc_id_318[i].v, this.model.doc.cuerpo.cc_id_315[i].v);
      }
    }
  }

  public operacionCs319(i: number) {
    //Limitante AFC
    ///SI Cas 303 =  2; (Cas 280 + Cas 305 + Cas 372 + Cas 328 + Cas 343+Cas 355 + Cas 494 + Cas 509 + Cas 538 + Cas 568  
    //+Cas 586 + Cas 608 + Cas 626 + Cas 648 + Cas 763) + 
    //(SI Cas 623 = 3; Cas 625) + (SI Cas 624 = 4; Cas 624) * 0,30  Y  <= 3800 uvt

    let valor = '0';
    const Porciento30 = '0.30';
    const UVT3800 = '3800';
    if (this.model.doc.cuerpo.cc_id_303[i] != undefined && Number(this.model.doc.cuerpo.cc_id_303[i].v) === 2) {

      const datos = ['cs_id_280', 'cs_id_305', 'cs_id_372', 'cs_id_328', 'cs_id_343', 'cs_id_355', 'cs_id_494', 'cs_id_509',
        'cs_id_538', 'cs_id_568', 'cs_id_586', 'cs_id_608', 'cs_id_626', 'cs_id_648', 'cs_id_763'];
      valor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model, datos, true);

    }
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_623.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_623[con].v) == 3 ) {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model.doc.cuerpo.cc_id_625[i].v);
        }
      }
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_623.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_623[con].v) == 4 ) {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model.doc.cuerpo.cc_id_624[i].v);
        }
      }
      
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, Porciento30);
    const UVT3800MU = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, UVT3800, this.UVT);
    valor = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, UVT3800MU) ? UVT3800MU : valor;
    valor = this.dutilidades.redondearValorMoneda(valor);
    this.model.doc.cuerpo.cc_id_319[i].v = valor;
  }

  public operacionCs320(i: number) {
    //Limitante aportes voluntarios pensión
   // Si Cas 303 = 2 Y Cas 370 = 2; (Cas 280 + Cas 305 + Cas 372 + Cas 328 + Cas 343+Cas 355 + Cas 494 + Cas 509 +  Cas 538 +  
   //Cas 568  +Cas 586 + Cas 608 + Cas 626 + Cas 648 + Cas 763) + (SI Cas 623 = 3; Cas 624) + (SI Cas 623 = 4; Cas 624)*0,30 
   //RESULTADO <= 3800 UVT

    let cas370bool = false;
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_370.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_370[con].v) == 2) {
          cas370bool = true;
          break;
        }
      }
    let valor = '0';
    const Porciento30 = '0.30';
    const UVT3800 = '3800';
    if (this.model.doc.cuerpo.cc_id_303[i] != undefined && Number(this.model.doc.cuerpo.cc_id_303[i].v) === 2 && cas370bool) {

      //this.model.doc.cuerpo.cs_id_305 =this.dutilidades.deshacerFormatoMoneda(this.model.doc.cuerpo.cs_id_305);
      const datos = ['cs_id_280', 'cs_id_305', 'cs_id_372', 'cs_id_328', 'cs_id_343', 'cs_id_355', 'cs_id_494', 'cs_id_509',
        'cs_id_538', 'cs_id_568', 'cs_id_586', 'cs_id_608',  'cs_id_648', 'cs_id_763','cs_id_626'];
      valor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model, datos, true);

    }
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_623.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_623[con].v) == 3 ||
          Number(this.model.doc.cuerpo.cc_id_623[con].v) == 4) {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model.doc.cuerpo.cc_id_624[i].v);
        }
      }
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, Porciento30);
    const UVT3800MU = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, UVT3800, this.UVT);
    valor = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, UVT3800MU) ? UVT3800MU : valor;
    valor = this.dutilidades.redondearValorMoneda(valor);
    this.model.doc.cuerpo.cc_id_320[i].v = valor;
  }

  public operacionCs321(i: number) {
    //Limitante cotización RAIS
    //Si Cas 303 = 2 Y Cas 370 = 2; (Cas 280 + Cas 305 + Cas 372 + Cas 328 + Cas 343+Cas 355 + Cas 494 + Cas 509 + Cas 538 +
    // Cas 568  +Cas 586 + Cas 608 + Cas 626 + Cas 648 + Cas 763) + (SI Cas 623 = 3; Cas 624) + (SI Cas 623 = 4; Cas 624)*0,25 
    //RESULTADO <= 2500 UVT

    let cas370bool = false;
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_370.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_370[con].v) === 2) {
          cas370bool = true;
          break;
        }
      }
    let valor = '0';
    const Porciento25 = '0.25';
    const UVT2500 = '2500';
    if (this.model.doc.cuerpo.cc_id_303[i] != undefined && Number(this.model.doc.cuerpo.cc_id_303[i].v) === 2 && cas370bool) {

      const datos = ['cs_id_280', 'cs_id_305', 'cs_id_372', 'cs_id_328', 'cs_id_343', 'cs_id_355', 'cs_id_494', 'cs_id_509',
        'cs_id_538', 'cs_id_568', 'cs_id_586', 'cs_id_608', 'cs_id_626', 'cs_id_648', 'cs_id_763'];
      valor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model, datos, true);

    }
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_623.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_623[con].v) == 3 ||
          Number(this.model.doc.cuerpo.cc_id_623[con].v) == 4) {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model.doc.cuerpo.cc_id_624[i].v);
        }
      }
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, Porciento25);
    const UVT2500MU = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, UVT2500, this.UVT);
    valor = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, UVT2500MU) ? UVT2500MU : valor;
    valor = this.dutilidades.redondearValorMoneda(valor);
    this.model.doc.cuerpo.cc_id_321[i].v = valor;
  }

  public operacionCs322(i: number) {
    //25% Exento 
    //Si Cas 303 = 2 Y Cas 370 = 2 Y Cas 318 = 0; (Cas 305- Cas 311 - 312- 313 -314 - 316 - 317  ) * 0,25 <=  9480 UVT anual

    let cas370bool = false;
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_370.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_370[con].v) == 2) {
          cas370bool = true;
          break;
        }
      }
    if (this.model.doc.cuerpo.cc_id_303[i] != undefined && this.model.doc.cuerpo.cc_id_303[i].v === '2' && cas370bool) {
      const Porciento25 = '0.25';
      const UVT9480 = '9480';
      let casillasResta = '0';
      let valor = '0';
      casillasResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, casillasResta, this.model.doc.cuerpo.cc_id_311[i].v);
      casillasResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, casillasResta, this.model.doc.cuerpo.cc_id_312[i].v);
      casillasResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, casillasResta, this.model.doc.cuerpo.cc_id_313[i].v);
      casillasResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, casillasResta, this.model.doc.cuerpo.cc_id_314[i].v);
      casillasResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, casillasResta, this.model.doc.cuerpo.cc_id_316[i].v);
      casillasResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, casillasResta, this.model.doc.cuerpo.cc_id_317[i].v);

      valor = this.model.doc.cuerpo.cs_id_305;

      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, casillasResta);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, Porciento25);
      const UVT9480MU = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, UVT9480, this.UVT);
      valor = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, UVT9480MU) ? UVT9480MU : valor;
      this.model.doc.cuerpo.cc_id_322[i].v = valor;

    }
  }

  public operacionCs307(i: number) {
    //Limitantes aporte voluntario a Cesantias
    //SI Cas 303 = 2 Y SI (Cas 280 + Cas 305 + Cas 371 + Cas 328 + Cas 343 +Cas 355 + Cas 494 + Cas 509 +  Cas 538 + Cas 568  +
    //Cas 586 + Cas 608 + Cas 626 + Cas 648 + Cas 763) + (SI Cas 623 = 3; Cas 624) + (SI Cas 623 = 4; Cas 624) ) / 12 < o = 2.500 UVT; 
    //(Cas 280 + Cas 305 + Cas 371 + Cas 328 + Cas 343 +Cas 355 + Cas 494 + Cas 509 +  Cas 538 + Cas 568  +Cas 586 + 
    //Cas 608 + Cas 626 + Cas 648 + Cas 763) + (SI Cas 623 = 3; Cas 624) + (SI Cas 623 = 4; Cas 624) ) / 12; Y SI Cas 311 < o = 
    //(Cas 280 + Cas 305 + Cas 371 + Cas 328 + Cas 343 +Cas 355 + Cas 494 + Cas 509 +  Cas 538 + Cas 568  +Cas 586 + Cas 608 + 
    //Cas 626 + Cas 648 + Cas 763) + (SI Cas 623 = 3; Cas 624) + (SI Cas 623 = 4; Cas 624) ) / 12; Cas 311; SI_NO 
    //(Cas 280 + Cas 305 + Cas 371 + Cas 328 + Cas 343 +Cas 355 + Cas 494 + Cas 509 +  Cas 538 + Cas 568  +Cas 586 + Cas 608 + 
    //Cas 626 + Cas 648 + Cas 763) + (SI Cas 623 = 3; Cas 624) + (SI Cas 623 = 4; Cas 624) ) / 12

    let cas370bool = false;
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_370.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_370[con].v) === 2) {
          cas370bool = true;
          break;
        }
      }
    let valor = '0';
    const Porciento25 = '0.25';
    const UVT2500 = '2500';
    const doce='12';
    
    if (this.model.doc.cuerpo.cc_id_303[i] != undefined && Number(this.model.doc.cuerpo.cc_id_303[i].v) === 2 && cas370bool) {

      const datos = ['cs_id_280', 'cs_id_305', 'cs_id_372', 'cs_id_328', 'cs_id_343', 'cs_id_355', 'cs_id_494', 'cs_id_509',
        'cs_id_538', 'cs_id_568', 'cs_id_586', 'cs_id_608', 'cs_id_626', 'cs_id_648', 'cs_id_763'];
      valor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model, datos, true);

    }
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_623.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_623[con].v) == 3 ||
          Number(this.model.doc.cuerpo.cc_id_623[con].v) == 4) {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model.doc.cuerpo.cc_id_625[i].v);
        }
      }
    
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_623.length; con++) {
        if (Number(this.model.doc.cuerpo.cc_id_623[con].v) == 3 ||
          Number(this.model.doc.cuerpo.cc_id_623[con].v) == 4) {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model.doc.cuerpo.cc_id_625[i].v);
        }
      }
    /*let cas311T='0';
    if (this.model.doc.cuerpo.cc_id_311 != undefined && this.model.doc.cuerpo.cc_id_311.length)
      for (let con = 0; con < this.model.doc.cuerpo.cc_id_311.length; con++) {
        cas311T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas311T, this.model.doc.cuerpo.cc_id_311[i].v);
        }*/
    
    //valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, Porciento25);
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, valor, doce);
    const UVT2500MU = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, UVT2500, this.UVT);
    valor = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, UVT2500MU) ? UVT2500MU :valor;
    valor = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cc_id_311[i].v, UVT2500MU) ? UVT2500MU : this.model.doc.cuerpo.cc_id_311[i].v;
    valor = this.dutilidades.redondearValorMoneda(valor);
    this.model.doc.cuerpo.cc_id_307[i].v = valor;
  }




  public obtenerTarifa(valorAsignado: number): string {
    let tarifaResultante = '';
    for (const rango of this.rangos) {
      if (rango.desde <= valorAsignado && valorAsignado <= rango.hasta) {
        tarifaResultante = rango.tarifa;
        break;
      }
    }
    return tarifaResultante;
  }

  public convertirPesosUvt(valorPesos) {
    let valorOperacion = new BigNumber2100(this.dutilidades.deshacerFormatoMoneda(valorPesos));
    valorOperacion = valorOperacion.div(this.UVT);
    valorOperacion = valorOperacion.toFormat();
    valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }


  //========= Fin Validaciones Casillas Ocultas=============//




  protected initializeTablaDesdeModelo() {


    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_309.length; i++) {
      this.modelForm.id = i;

      this.modelForm.pagador = this.model.doc.cuerpo.cc_id_309[i].v;
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_302[i].v;
      this.modelForm.tipoRenta = this.model.doc.cuerpo.cc_id_303[i].v;
      if(this.listaTipoRenta && this.listaTipoRenta.length>0){
        const tipoRenta = this.listaTipoRenta.find(item => item.valor == this.model.doc.cuerpo.cc_id_303[i].v);
        this.modelForm.descTipoRenta = tipoRenta ? tipoRenta.nombre : '';
      }
      this.modelForm.valor = this.dutilidades.obtenerFormatoMoneda(this.model.doc.cuerpo.cc_id_304[i].v);
      this.modelForm.retencion = this.model.doc.cuerpo.cc_id_310[i].v;
      this.modelForm.aportesalud = this.model.doc.cuerpo.cc_id_312[i].v;
      this.modelForm.aporteoblipension = this.model.doc.cuerpo.cc_id_313[i].v;
      this.modelForm.aportevolpension = this.model.doc.cuerpo.cc_id_314[i].v;
      this.modelForm.aportesAFCoAVC = this.model.doc.cuerpo.cc_id_315[i].v;
      this.modelForm.cesantias = this.model.doc.cuerpo.cc_id_311[i].v;
      this.modelForm.limitanteAFC = this.model.doc.cuerpo.cc_id_319[i].v;
      this.modelForm.limitanteaportevolpension = this.model.doc.cuerpo.cc_id_320[i].v;
      this.modelForm.limitanteRAIS = this.model.doc.cuerpo.cc_id_321[i].v;
      this.modelForm.veinticincoexento = this.model.doc.cuerpo.cc_id_322[i].v;
      this.modelForm.cotizavolRAIS = this.model.doc.cuerpo.cc_id_317[i].v;
      this.modelForm.arl = this.model.doc.cuerpo.cc_id_316[i].v;
      this.modelForm.limitanteaportevolCesantias = this.model.doc.cuerpo.cc_id_307[i].v;
      this.modelForm.costosGastos = this.model.doc.cuerpo.cc_id_318[i].v;
      this.modelForm.perdidas = this.model.doc.cuerpo.cc_id_308[i].v;

      //=====
      //=====
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida() {

    let indexModel = this.model.doc.cuerpo.cc_id_309.length;

    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_4045','VAR_4046','VAR_4047','VAR_4048','VAR_4051','VAR_2002','VAR_2003','VAR_2004','VAR_2180','VAR_2194','VAR_2195','VAR_2474','VAR_2475','VAR_2476','VAR_2399','VAR_2403','VAR_2404','VAR_3660','VAR_3661','VAR_3662','VAR_1734','VAR_1735','VAR_1736','VAR_2069','VAR_2070','VAR_2071','VAR_1064'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      
      const grupos=[
        ['VAR_4045','VAR_4046','VAR_4047','VAR_4048','VAR_4051','VAR_2002','VAR_2003','VAR_2004','VAR_2180','VAR_2194','VAR_2195','VAR_2474','VAR_2475','VAR_2476','VAR_2399','VAR_2403','VAR_2404','VAR_3660','VAR_3661','VAR_3662'],
        ['VAR_1734','VAR_1735','VAR_1736','VAR_2069','VAR_2070','VAR_2071'],
        ['VAR_1064']
      ];

      if (resData) {

        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {

            this.modelForm.id = indexModel;
            this.modelForm.pagador = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.origen = "0";
            this.modelForm.tipoRenta = "2";
            this.modelForm.descTipoRenta  = this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;

            this.modelForm.retencion = '0';
            this.modelForm.aportesalud = '0';
            this.modelForm.aporteoblipension = '0';
            this.modelForm.aportevolpension = '0';
            this.modelForm.aportesAFCoAVC = '0';
            this.modelForm.cesantias = '0';
            this.modelForm.limitanteAFC = '0';
            this.modelForm.limitanteaportevolpension = '0';
            this.modelForm.limitanteRAIS = '0';
            this.modelForm.veinticincoexento = '0';
            this.modelForm.cotizavolRAIS = '0';
            this.modelForm.arl = '0';
            this.modelForm.limitanteaportevolCesantias = '0';
            this.modelForm.costosGastos = '0';
            this.modelForm.perdidas = '0';

            
            let itemGrupoFormPorEditar:Form1 = null;

            //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
            let idGrupo:number = -1;
            for(let k=0;k<grupos.length;k++){
              if(grupos[k].includes(resData[i].key)){
                idGrupo=k;
                break;
              }
            }

            //1. El nit ya existe? NO ->1:Agregar
            if(this.dataSourceBody.find((el)=>{
              return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
            })==undefined){
              itemGrupoFormPorEditar = null;
            }else{

              //2. Trae array de solo los del NIT
              let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                  return el;
                }
              });

              //3. Recorrer array de solo los del NIT
              for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                //En el registro existe una variable del GRUPO? 
                //  - NO: Debe Editar el registro y deja de buscar
                //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                if(!dataGrupo){
                  itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                  break;
                }
              }

            }
            
            //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
            if(itemGrupoFormPorEditar){
              this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                if(itemModelForm.id == itemGrupoFormPorEditar.id){
                  itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                  itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                }
                return itemModelForm;
              });
            }else{
              this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
              this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
              this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
              this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
              this.redondearFormData();
              this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
              this.dataSourceBody.push(this.modelForm);
              this.inicializeForm();
              indexModel++;
            }

          }
        }

      }
    }
    this.operacionCs305();
  }

  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
    switch(idGrupo){//Depende de la variable array grupos
      case 0:
        itemModelForm.valor=String(valor);
      break;
      case 1:
        itemModelForm.retencion=String(valor);
      break;
      case 2:
        itemModelForm.aporteoblipension=String(valor);
      break;
      default:
      break;
    }
    return itemModelForm;
  }

  public editModeloDesdeForm() {

    this.model.doc.cuerpo.cc_id_309[this.modelForm.id].v = this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_302[this.modelForm.id].v = this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_303[this.modelForm.id].v = this.modelForm.tipoRenta.toString();
    this.model.doc.cuerpo.cc_id_304[this.modelForm.id].v = this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_310[this.modelForm.id].v = this.modelForm.retencion.toString(); //Retención
    this.model.doc.cuerpo.cc_id_312[this.modelForm.id].v = this.modelForm.aportesalud.toString(); //Aporte a salud
    this.model.doc.cuerpo.cc_id_313[this.modelForm.id].v = this.modelForm.aporteoblipension.toString(); //Aporte obligatorio pensión
    this.model.doc.cuerpo.cc_id_314[this.modelForm.id].v = this.modelForm.aportevolpension.toString(); //Aporte voluntario pensión
    this.model.doc.cuerpo.cc_id_315[this.modelForm.id].v = this.modelForm.aportesAFCoAVC.toString(); //Aportes cuentas AFC O AVC
    this.model.doc.cuerpo.cc_id_311[this.modelForm.id].v = this.modelForm.cesantias.toString(); //Cesantías
    this.model.doc.cuerpo.cc_id_319[this.modelForm.id].v = this.modelForm.limitanteAFC.toString();
    this.model.doc.cuerpo.cc_id_320[this.modelForm.id].v = this.modelForm.limitanteaportevolpension.toString();
    this.model.doc.cuerpo.cc_id_321[this.modelForm.id].v = this.modelForm.limitanteRAIS.toString();
    this.model.doc.cuerpo.cc_id_322[this.modelForm.id].v = this.modelForm.veinticincoexento.toString();
    this.model.doc.cuerpo.cc_id_317[this.modelForm.id].v = this.modelForm.cotizavolRAIS.toString();
    this.model.doc.cuerpo.cc_id_316[this.modelForm.id].v = this.modelForm.arl.toString();
    this.model.doc.cuerpo.cc_id_307[this.modelForm.id].v = this.modelForm.limitanteaportevolCesantias.toString();
    this.model.doc.cuerpo.cc_id_318[this.modelForm.id].v = this.modelForm.costosGastos.toString();
    this.model.doc.cuerpo.cc_id_308[this.modelForm.id].v = this.modelForm.perdidas.toString();

  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;

    this.model.doc.cuerpo.cc_id_309.push({ it: i, v: this.modelForm.pagador });
    this.model.doc.cuerpo.cc_id_302.push({ it: i, v: this.modelForm.origen.toString() });
    this.model.doc.cuerpo.cc_id_303.push({ it: i, v: this.modelForm.tipoRenta.toString() });
    this.model.doc.cuerpo.cc_id_304.push({ it: i, v: this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString()) });
    this.model.doc.cuerpo.cc_id_310.push({ it: i, v: this.modelForm.retencion.toString() }); //Retención
    this.model.doc.cuerpo.cc_id_312.push({ it: i, v: this.modelForm.aportesalud.toString() }); //Aporte a salud
    this.model.doc.cuerpo.cc_id_313.push({ it: i, v: this.modelForm.aporteoblipension.toString() }); //Aporte obligatorio pensión
    this.model.doc.cuerpo.cc_id_314.push({ it: i, v: this.modelForm.aportevolpension.toString() }); //Aporte voluntario pensión
    this.model.doc.cuerpo.cc_id_315.push({ it: i, v: this.modelForm.aportesAFCoAVC.toString() }); //Aportes cuentas AFC O AVC
    this.model.doc.cuerpo.cc_id_311.push({ it: i, v: this.modelForm.cesantias.toString() }); //Cesantías
    this.model.doc.cuerpo.cc_id_319.push({ it: i, v: this.modelForm.limitanteAFC.toString() });
    this.model.doc.cuerpo.cc_id_320.push({ it: i, v: this.modelForm.limitanteaportevolpension.toString() });
    this.model.doc.cuerpo.cc_id_321.push({ it: i, v: this.modelForm.limitanteRAIS.toString() });
    this.model.doc.cuerpo.cc_id_322.push({ it: i, v: this.modelForm.veinticincoexento.toString() });
    this.model.doc.cuerpo.cc_id_317.push({ it: i, v: this.modelForm.cotizavolRAIS.toString() });
    this.model.doc.cuerpo.cc_id_316.push({ it: i, v: this.modelForm.arl.toString() });
    this.model.doc.cuerpo.cc_id_307.push({ it: i, v: this.modelForm.limitanteaportevolCesantias.toString() });
    this.model.doc.cuerpo.cc_id_318.push({ it: i, v: this.modelForm.costosGastos.toString() });
    this.model.doc.cuerpo.cc_id_308.push({ it: i, v: this.modelForm.perdidas.toString() });

    this.operacionCs305();

    this.operacionCs308(this.modelForm.id);
    this.operacionCs319(this.modelForm.id);
    this.operacionCs320(this.modelForm.id);
    this.operacionCs321(this.modelForm.id);
    this.operacionCs322(this.modelForm.id);
    this.operacionCs307(this.modelForm.id);


    console.log(this.model.doc.cuerpo.cc_id_309);
    console.log(this.model.doc.cuerpo.cc_id_302);
    console.log(this.model.doc.cuerpo.cc_id_303);
    console.log(this.model.doc.cuerpo.cc_id_304);
    console.log(this.model.doc.cuerpo.cc_id_310);
    console.log(this.model.doc.cuerpo.cc_id_312);
    console.log(this.model.doc.cuerpo.cc_id_313);
    console.log(this.model.doc.cuerpo.cc_id_314);
    console.log(this.model.doc.cuerpo.cc_id_315);
    console.log(this.model.doc.cuerpo.cc_id_311);
    console.log(this.model.doc.cuerpo.cc_id_319);
    console.log(this.model.doc.cuerpo.cc_id_320);
    console.log(this.model.doc.cuerpo.cc_id_321);
    console.log(this.model.doc.cuerpo.cc_id_322);
    console.log(this.model.doc.cuerpo.cc_id_317);
    console.log(this.model.doc.cuerpo.cc_id_316);
    console.log(this.model.doc.cuerpo.cc_id_307);
    console.log(this.model.doc.cuerpo.cc_id_318);
    console.log(this.model.doc.cuerpo.cc_id_308);

  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_309.splice(index, 1);
    this.model.doc.cuerpo.cc_id_302.splice(index, 1);
    this.model.doc.cuerpo.cc_id_303.splice(index, 1);
    this.model.doc.cuerpo.cc_id_304.splice(index, 1);
    this.model.doc.cuerpo.cc_id_310.splice(index, 1);
    this.model.doc.cuerpo.cc_id_312.splice(index, 1);
    this.model.doc.cuerpo.cc_id_313.splice(index, 1);
    this.model.doc.cuerpo.cc_id_314.splice(index, 1);
    this.model.doc.cuerpo.cc_id_315.splice(index, 1);
    this.model.doc.cuerpo.cc_id_311.splice(index, 1);
    this.model.doc.cuerpo.cc_id_319.splice(index, 1);
    this.model.doc.cuerpo.cc_id_320.splice(index, 1);
    this.model.doc.cuerpo.cc_id_321.splice(index, 1);
    this.model.doc.cuerpo.cc_id_322.splice(index, 1);
    this.model.doc.cuerpo.cc_id_317.splice(index, 1);
    this.model.doc.cuerpo.cc_id_316.splice(index, 1);
    this.model.doc.cuerpo.cc_id_307.splice(index, 1);
    this.model.doc.cuerpo.cc_id_318.splice(index, 1);
    this.model.doc.cuerpo.cc_id_308.splice(index, 1);


    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_309.length; i++) {
      this.model.doc.cuerpo.cc_id_309[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_302[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_303[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_304[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_310[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_312[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_313[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_314[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_315[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_311[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_319[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_320[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_321[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_322[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_317[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_316[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_307[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_318[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_308[i].it = i + 1;
    }
    this.operacionCs305();
  }
  //////////////////Continuar aquí
  public validateFormCompleted(): boolean {
    return this.modelForm.pagador == undefined || this.modelForm.pagador == null || this.modelForm.pagador.trim() == "" ||
      this.modelForm.origen == undefined || this.modelForm.origen == null ||
      this.modelForm.valor == undefined || this.modelForm.valor == null || this.modelForm.valor == "0" ||
      this.modelForm.retencion == undefined || this.modelForm.retencion == null ||
      this.modelForm.cesantias == undefined || this.modelForm.cesantias == null ||
      this.modelForm.aporteoblipension == undefined || this.modelForm.aporteoblipension == null ||
      this.modelForm.aportesalud == undefined || this.modelForm.aportesalud == null ||
      this.modelForm.cotizavolRAIS == undefined || this.modelForm.cotizavolRAIS == null ||
      this.modelForm.aportesAFCoAVC == undefined || this.modelForm.aportesAFCoAVC == null ||
      this.modelForm.aportevolpension == undefined || this.modelForm.aportevolpension == null
  }


  public redondearFormData() {
    this.modelForm.valor = this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(), true);


  }




  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();


  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla == this.OPERACION_EDITAR) {

        if (this.modelForm.origen == "0") {
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });

      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_309.length;
        this.modelForm.pagador = this.modelForm.pagador;

        this.modelForm.tipoRenta=this.modelForm.tipoRenta;
        if(this.listaTipoRenta && this.listaTipoRenta.length>0){
          const tipoRenta = this.listaTipoRenta.find(item => item.valor == this.modelForm.tipoRenta);
          this.modelForm.descTipoRenta = tipoRenta ? tipoRenta.nombre : '';
        }

//    this.modelForm.descTipoRenta = this.listaTipoRenta[(this.modelForm.tipoRenta).toString()].nombre;
        this.modelForm.origen = "2";
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs305();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    //  this.operacionCs305();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];

    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }



  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }




  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs305();
    this.dialogRef.close("");
  }
  public async guardar() {

    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_309 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.modelForm.id = i;
      this.addToModeloDesdeForm();
    }

    // const componentBeneficiosDeduccionesEsp = this._componentFactory.createModalComponent(BeneficiosTributariosDeduccionesEspecialesModalComponent, { model: this.model });
    // componentBeneficiosDeduccionesEsp.instance.uvt = this.UVT;
    // componentBeneficiosDeduccionesEsp.instance.actualizarDataTrabInd();


    // const componentAsalariado = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
    // componentAsalariado.instance.uvt = this.UVT;
    // componentAsalariado.instance.operacionCs280();

    /*const componentBeneficiosRentasExentasImp = this._componentFactory.createModalComponent(BeneficiosRentasExentasDeImpuestoModalComponent, { model: this.model });
    //componentBeneficiosRentasExentasImp.instance.uvt = this.UVT;
    componentBeneficiosRentasExentasImp.instance.actualizarDataTrabInd();
    */

    // const componentBenIngNoGrav = this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados,  {model: this.model} );
    // componentBenIngNoGrav.instance.reset();
    // componentBenIngNoGrav.instance.initializeTablaDesdeModelo();
    // for(let i=0; i<componentBenIngNoGrav.instance.dataSourceBody.length; i++){
    //   componentBenIngNoGrav.instance.modelForm = componentBenIngNoGrav.instance.dataSourceBody[i];
    //   componentBenIngNoGrav.instance.operacionCS691();
    //   this.model.doc.cuerpo.cc_id_691[i].v = componentBenIngNoGrav.instance.modelForm.limitesRAIS;
    //   }
    // componentBenIngNoGrav.instance.guardar();
    

    this.saveModel.emit(true);
    //if(this.indexStepper==this.stepsList.length-1){

console.log('modelo en independientes: ',this.model);
    this.closeModal();
    //} 
  }
  public borrarTabla() {
    this.dataSourceBody = [];
  }

  protected operarCamposCuerpoARRAY(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {
    let valores = [];
    for (let i in campos) {
      let casilla = modelo.doc.cuerpo[campos[i]] && modelo.doc.cuerpo[campos[i]] != undefined && modelo.doc.cuerpo[campos[i]] != null ? modelo.doc.cuerpo[campos[i]] : "0";

      //=====
      if (Array.isArray(casilla) && casilla.length === 0) {
        casilla = "0";

        if (this.dutilidades.validarValorNumerico(casilla)) {
          let valor = this.dutilidades.redondearValorMoneda(casilla);
          valores.push(valor);
          //valores.push(modelo.doc.cuerpo[campos[i]]);
        } else {
          valores.push('0');
        }
      }
    }
    let retorno = '0';
    if (valores.length > 0)
      retorno = this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
    return retorno;
  }
   /**
    * @desc Funcion para obtener los valores del modelo e operar con ellos
    * @param {DTipoOperacionAritmetica} operacion
    * @param {DDocumento} modelo
    * @param {Array<string>} campos
    * @param {boolean} formatear
    * @return {String}
    */
    protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
      let valores = [];
      for (let i in campos) {
          if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
              let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
              valores.push(valor);
              //valores.push(modelo.doc.cuerpo[campos[i]]);
          } else {
              valores.push('0');
          }
      }
      return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }









}






// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component.ts